import React from 'react';
// import type { DatePickerProps } from 'antd';
import { StyledDatePicker } from './index.styled';
import moment, { Moment } from 'moment';

type AppDatePickerProps = {
  onChangeValue?: (date: unknown, dateString: string | string[]) => void;
  value?: string | Moment | null;
  [x: string]: any;
};

const AppDatePicker: React.FC<AppDatePickerProps> = ({
  onChangeValue,
  value,
  ...rest
}: AppDatePickerProps) => {
  const onChange = (date: unknown, dateString: string | string[]) => {
    console.log(date, dateString);
    onChangeValue && onChangeValue(date, dateString);
  };
  return (
    <StyledDatePicker
      format="DD/MM/YYYY"
      onChange={onChange}
      value={value ? moment(value) : null}
      {...rest}
    />
  );
};
export default AppDatePicker;
